import { render } from "./school.vue?vue&type=template&id=5814168a&scoped=true&ts=true"
import script from "./school.vue?vue&type=script&lang=ts"
export * from "./school.vue?vue&type=script&lang=ts"

import "./school.vue?vue&type=style&index=0&id=5814168a&lang=less&scoped=true"

import exportComponent from "E:\\project\\ale\\建大车辆入校预约\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5814168a"]])

export default __exports__